export default "__VITE_ASSET__kM7O9FI3__"